/*************************************************/
/* NEWS                                          */
/*************************************************/

export function collapsedText() {
    const collapsedTextSelector = ".collapsed-text";
    const collapsedContentClass = "collapsed-text__content--collapsed";
    const visibleContentClass = "collapsed-text__content--visible";
    const collapsedTextExpandButtonSelector = ".collapsed-text__button--expand";
    const collapsedTextCollapseButtonSelector = ".collapsed-text__button--collapse";

    const handleImageTextComponent = function(collapsedTextField,operator){
        //Special case for Image Text Component
        const imageTextOverlay = collapsedTextField.closest('.image-text-item__text');
        if(imageTextOverlay){
            const imageTextOverlayStyles = window.getComputedStyle(imageTextOverlay);
            const imageTextOverlayPosition = imageTextOverlayStyles.getPropertyValue('position');
            if(imageTextOverlayPosition == 'absolute') {
                const imageText = imageTextOverlay.closest('.image-text-item');

                if(imageText){
                    const imageTextStyles = window.getComputedStyle(imageText);
                    const topPadding = imageTextStyles.getPropertyValue('padding-top');
                    const bottomPadding = imageTextStyles.getPropertyValue('padding-bottom');
                    const additionalPadding = Math.round(collapsedTextField.scrollHeight / 2);
                    const newPaddingTopValue = `calc(${topPadding} ${operator} ${additionalPadding}px)`;
                    const newPaddingBottomValue = `calc(${bottomPadding} ${operator} ${additionalPadding}px)`;

                    imageText.style.paddingTop = newPaddingTopValue;
                    imageText.style.paddingBottom = newPaddingBottomValue;
                }
            }
        }
    }

    const init = function () {
        var expandButtons = document.querySelectorAll(collapsedTextExpandButtonSelector);
        if (expandButtons.length > 0) {
            expandButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const collapsedTextParent = e.target.closest(collapsedTextSelector);
                    const collapsedTextField = collapsedTextParent.getElementsByClassName(collapsedContentClass)[0];

                    if(collapsedTextField) {
                        handleImageTextComponent(collapsedTextField,'+');

                        collapsedTextField.style.height = collapsedTextField.scrollHeight + 'px';
                        collapsedTextField.setAttribute('aria-expanded',true);
                        e.target.style.display = "none";
                        collapsedTextParent.querySelector(collapsedTextCollapseButtonSelector).style.display = null;

        
                    }
                });
            });
        }

        var collapseButtons = document.querySelectorAll(collapsedTextCollapseButtonSelector);
        if (collapseButtons.length > 0) {
            collapseButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const collapsedTextParent = e.target.closest(collapsedTextSelector);
                    const collapsedTextField = collapsedTextParent.getElementsByClassName(collapsedContentClass)[0];

                    if(collapsedTextField) {
                        handleImageTextComponent(collapsedTextField,'-');

                        collapsedTextField.style.height = 0 + 'px';
                        collapsedTextField.setAttribute('aria-expanded',false);
                        e.target.style.display = "none";
                        collapsedTextParent.querySelector(collapsedTextExpandButtonSelector).style.display = null;

                    }
                });
            });
        }
    };


    init();
}
